module.exports = __webpack_public_path__ + "img/logo.cfa19836.png";